'use strict';

export default {
    getDate(time) {
        if (!time) return
        var d = new Date(time);
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + (d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()) + ':' + (d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds());
        return date;
    }
}




// WEBPACK FOOTER //
// ./src/utils/util.js